// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const cetitan: PokeData = {
  "id": 975,
  "name": "cetitan",
  "height": 45,
  "weight": 7000,
  "base_experience": 182,
  "types": [
    PokeType.ICE
  ],
  "api_moves": [
    "tackle",
    "body-slam",
    "take-down",
    "double-edge",
    "growl",
    "blizzard",
    "amnesia",
    "rest",
    "flail",
    "powder-snow",
    "bounce",
    "avalanche",
    "ice-shard",
    "echoed-voice",
    "ice-spinner"
  ],
  "moves": [
    "tackle",
    "body-slam",
    "growl",
    "blizzard",
    "avalanche",
    "ice-shard",
    "chilly-reception",
    "ice-wave",
    "ice-punch",
    "icicle-dagger",
    "sheer-cold",
    "ice-fang",
    "aurora-veil"
  ],
  "evolution_chain": {
    "id": 511,
    "item": null,
    "species": [
      {
        "name": "cetoddle",
        "order": 947,
        "types": [
          PokeType.ICE
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "cetitan",
        "order": 948,
        "types": [
          PokeType.ICE
        ],
        "evolves_from_species_id": 974,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "ice-stone"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 153,
    "speed": 97,
    "ability_power": 150
  },
  "stat_changes": [],
  "catch_rate": 50,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
